<iframe [hidden]="!isIFrameLoaded" id="iframe" (load)="onLoad()" (error)="onError()" [src]="url"></iframe>

<app-generic-loading *ngIf="!isIFrameLoaded"></app-generic-loading>
